const overlay = document.querySelector('.js-how-overlay');
const box = document.querySelector('.js-how-overlay--box');
let activeStep = 1;

const toggleOverlay = () => {
    document.body.classList.toggle('overlay-active');
};

const initHowTo = () => {
    if (!overlay || getVisitFromLocalStorage()) return;

    updateBox(getActiveSegment());
    toggleOverlay();
    activeStep = 2;

    overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
            handleOverlayClick();
        }
    });

    const triggerNext = document.querySelector('.js-how-overlay--trigger-next');
    triggerNext.addEventListener('click', () => {
        handleOverlayClick();
    });

    const triggerSkip = document.querySelector('.js-how-overlay--trigger-skip');
    triggerSkip.addEventListener('click', () => {
        removeAllBoxes();
        setVisitInLocalStorage();

        setTimeout(() => {
            toggleOverlay();
        }, 200);
    });
};

const getActiveSegment = () => {
    return document.querySelector('.wheel__segment.active');
};

const getBoundingBox = (segment) => {
    const segmentContent = segment.querySelector('.wheel__segment-content');
    const { width, height, top, left } = segmentContent.getBoundingClientRect();
    return { width, height, top, left };
};

const getSegmentByIndex = (index) => {
    return document.querySelector(`.wheel__segment[data-index="${index}"]`);
};

const updateBox = (segment) => {
    const { width, height, top, left } = getBoundingBox(segment);

    const scaledWidth = width * 1.5;
    const scaledHeight = height * 1.5;

    const widthDiff = (scaledWidth - width) / 2;
    const heightDiff = (scaledHeight - height) / 4;

    box.style.width = `${scaledWidth}px`;
    box.style.height = `${scaledHeight}px`;
    box.style.top = `${top - heightDiff}px`;
    box.style.left = `${left - widthDiff}px`;
};

const handleOverlayClick = () => {
    updateOverlayDataStep();

    if (activeStep === 2) {
        handleSecondStep();
    }

    if (activeStep === 3) {
        handleThirdStep();
    }

    if (activeStep === 4) {
        handleFourthStep();
    }

    if (activeStep === 5) {
        handleFifthStep();
    }

    if (activeStep >= 6) {
        removeAllBoxes();

        setTimeout(() => {
            toggleOverlay();
        }, 200);

        setVisitInLocalStorage();
    }

    activeStep++;
};

const handleSecondStep = () => {
    const segment = getSegmentByIndex(2);
    updateBox(segment);
};

const setVisitInLocalStorage = () => {
    localStorage.setItem('how-to-visit', 'true');
};

const getVisitFromLocalStorage = () => {
    return localStorage.getItem('how-to-visit');
};

const handleThirdStep = () => {
    let subcategories = document.querySelector('.header__subcategories');
    if (isMobile()) {
        subcategories = document.querySelector('.header__text-dropdown');
    }

    const { width, height, top, left } = subcategories.getBoundingClientRect();

    let addPoints = 40;
    if (isMobile()) {
        addPoints = -10;
    }

    box.style.width = `${width + addPoints}px`;
    box.style.left = `${left - addPoints / 2}px`;

    box.style.height = `${height + 20}px`;
    box.style.top = `${top - 10}px`;
};

const handleFourthStep = () => {
    const searchBox = document.querySelector('.js-news-search');
    const { width, height, top, left } = searchBox.getBoundingClientRect();

    let addPoints = 40;
    if (isMobile()) {
        addPoints = 10;
    }

    box.style.width = `${width + addPoints}px`;
    box.style.left = `${left - addPoints / 2}px`;
    box.style.height = `${height + 20}px`;
    box.style.top = `${top - 10}px`;
};

const handleFifthStep = () => {
    const searchBox = document.querySelector('.js-wheel--show-results--main');
    const { width, height, top, left } = searchBox.getBoundingClientRect();

    box.style.width = `${width + 20}px`;
    box.style.height = `${height + 20}px`;
    box.style.top = `${top - 10}px`;
    box.style.left = `${left - 10}px`;
};

const updateOverlayDataStep = () => {
    overlay.dataset.step = activeStep;
};

const removeAllBoxes = () => {
    const boxes = document.querySelectorAll('.js-how-overlay--box, .js-how-overlay--text, .js-how-overlay--dot');
    boxes.forEach((box) => {
        box.style.overflow = 'hidden';
        box.style.width = '0px';
        box.style.height = '0px';
        box.style.top = '0px';
        box.style.left = '0px';
        box.style.opacity = '0';
    });
};

const isMobile = () => {
    return window.innerWidth <= 1024;
};

const getClosestViewportEdge = (element, threshold = 0) => {
    if (!element) return null;

    const rect = element.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    let edges = [];

    if (rect.top <= threshold) edges.push('top');
    if (rect.left <= threshold) edges.push('left');
    if (viewportWidth - rect.right <= threshold) edges.push('right');
    if (viewportHeight - rect.bottom <= threshold) edges.push('bottom');

    return edges.length ? edges : null;
};

export default initHowTo;
